/** ข้อความภาษาอังกฤษจากระบบ/เฟรมเวิร์กที่ไม่ควรแสดงต่อผู้ใช้ทั่วไป */
function isTechnicalEnglishMessage(msg: string): boolean {
  return (
    /server components/i.test(msg) ||
    /digest property/i.test(msg) ||
    /omitted in production/i.test(msg) ||
    /^an error occurred\b/i.test(msg) ||
    /\bUnhandled Runtime Error\b/i.test(msg) ||
    /\bInternal Server Error\b/i.test(msg) ||
    /\bUnexpected token\b/i.test(msg) ||
    /^Error:\s/i.test(msg) ||
    /\n\s+at\s/m.test(msg)
  );
}

export type FriendlyThaiErrorContext = "default" | "extract";

const GENERIC =
  "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง หากยังไม่ได้ผล ลองปิดแล้วเปิดหน้านี้ใหม่";
const EXTRACT_GENERIC =
  "อ่านข้อมูลจากไฟล์ไม่สำเร็จ — ลองส่งรูปที่ชัดกว่านี้ หรือพิมพ์ข้อมูลเอง";

function genericForContext(context: FriendlyThaiErrorContext): string {
  return context === "extract" ? EXTRACT_GENERIC : GENERIC;
}

/**
 * แปลงข้อความ error เป็นภาษาไทยที่เข้าใจง่าย — ไม่แสดงข้อความเทคนิคภาษาอังกฤษต่อผู้ใช้
 */
export function toFriendlyThaiErrorMessage(
  raw: string,
  context: FriendlyThaiErrorContext = "default",
): string {
  const msg = (raw || "").trim();
  if (!msg) return "";

  if (/[ก-๙]/.test(msg)) return msg;

  if (msg.includes("Body exceeded 1 MB limit")) {
    return "ไฟล์ใหญ่เกินที่ระบบรับได้ (เกิน 1 MB) — ลองส่งรูปเดียว/บีบอัดรูป หรือใช้ไฟล์ PDF ที่ชัดเจนกว่านี้";
  }

  if (
    msg.includes("Request Entity Too Large") ||
    msg.includes("Payload Too Large") ||
    /\b413\b/.test(msg)
  ) {
    return "ไฟล์ใหญ่เกินไป — ลองบีบอัดรูป/ส่งรูปเดียว หรือใช้ไฟล์ที่ขนาดเล็กลง";
  }

  if (
    msg.includes("Failed to fetch") ||
    msg.includes("NetworkError") ||
    msg.includes("Network Error")
  ) {
    return "เชื่อมต่อไม่สำเร็จ — ลองตรวจอินเทอร์เน็ตแล้วลองใหม่อีกครั้ง";
  }

  if (/502|503|504|bad gateway|service unavailable/i.test(msg)) {
    return "เซิร์ฟเวอร์ระบบชั่วคราวไม่พร้อม กรุณาลองใหม่อีกครั้งในสักครู่";
  }

  if (isTechnicalEnglishMessage(msg)) {
    return genericForContext(context);
  }

  // ข้อความภาษาอังกฤษอื่นที่ไม่รู้จัก — ไม่ต่อท้ายข้อความเดิม
  return genericForContext(context);
}
